<template>
    <div>
        <div v-if="!nospace" class="square">
            <vue-dropzone
                v-if="dropzoneEnabled"
                ref="myVueDropzone"
                class="dropzone dropzone-multi disabled"
                id="dropzone"
                :options="dropzoneOptions"
                :useCustomSlot=true
                v-on:vdropzone-error="dropError"
                v-on:vdropzone-sending="sendingEvent"
                v-on:vdropzone-complete="completeEvent"
                v-on:vdropzone-files-added="addFiles"
            >
                <div class="dropzone-panel mb-lg-0 mb-2">
                    <span class="uploadDisable" v-if="!uploadEnabled"></span>
                    <a id="dropzone-select" class="dropzone-select">
                        <svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16"><path d="M11 10V0H5v10H2l6 6 6-6h-3zm0 0" fill-rule="evenodd"></path></svg>
                        Drop Files Here to<br />Add to Current Layer
                    </a>
                </div>
            </vue-dropzone>
            <div class="disabled_dropzone" v-else>Project read-only.</div>
        </div>
        <div v-else class="square square_nospace">
            <span class="square_nospace_header">Sorry!</span>
            You have exceeded your disk space limit and cannot upload new files.
        </div>
        <div class="dropzone_counter">{{uploadedFiles}}/{{overallFiles}} uploaded <span class="errorFiles" v-if="errorFiles">({{errorFiles}} errors)</span></div>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";

export default {
    name: "DropBox",
    components: {
        vueDropzone: vue2Dropzone
    },
    computed: {
        projects () {
            return this.$store.getters.projects;
        },
        current_layer () {
            return this.$store.getters.currentLayer;
        },
        user (){
            return this.$store.getters.user;
        }
    },
    watch: {
        current_layer: function (val){
            if (val.layer.id == 0) this.dropzoneEnabled = false;
            else this.dropzoneEnabled = false;
        }
    },
    data () {
        return {
            overallFiles: 0,
            uploadedFiles: 0,
            uploadedArray: [],
            uploadEnabled: true,
            errorFiles: 0,
            dropzoneEnabled: false,
            nospace: false,
            dropzoneOptions: {
                url: this.$store.getters.uploadUrl,
                parallelUploads: 5,
                timeout: 3600000,
                paramName: "testimage",
                clickable: '.dropzone-select',
                previewTemplate: this.template(),
                headers: {
                    'Authorization': 'Bearer '+ localStorage.teo_token
                }
            }
        }
    },
    methods: {
        addFiles(file){
            this.uploadedFiles = 0;
            this.errorFiles = 0;
            this.overallFiles = file.length;
            this.uploadEnabled = false;
            this.uploadedArray = [];
        },
        sendingEvent (file, xhr, formData) {
            formData.append('project_hashid', this.current_layer.project.hashid);
            formData.append('layer_id', this.current_layer.layer.id);
        },
        completeEvent (response) {
            this.uploadedFiles = this.overallFiles - this.$refs.myVueDropzone.getActiveFiles().length;

            let res =  JSON.parse(response.xhr.response);
            if (res.status == 'error') this.$store.dispatch('setError', res.error_message);

            this.uploadedArray.push({
                name: response.name,
                type: response.type,
                size: response.size,
                status: response.status
            });

            if (this.$refs.myVueDropzone.getActiveFiles().length == 0){
                this.uploadEnabled = true;
                const layer = {
                    hashid : this.current_layer.project.hashid,
                    id: this.current_layer.layer.id
                };
                const data = {
                    hashid : this.current_layer.project.hashid,
                    id: this.current_layer.layer.id,
                    data: this.uploadedArray
                };
                this.$store.dispatch('finishUploading', data);
                this.$store.dispatch('getCurrentLayer', layer);
                this.$store.dispatch('getLayers', this.current_layer.project.hashid);
                this.$store.dispatch('getProjects').then(() => {
                    const prjkey = Object.keys(this.projects).find(k=>this.projects[k].hashid===this.current_layer.project.hashid);
                    const lyrkey = Object.keys(this.projects[prjkey].layers).find(k=>this.projects[prjkey].layers[k].id===this.current_layer.layer.id);
                    this.projects[prjkey].active = true;
                    this.projects[prjkey].layers[lyrkey].active = true;
                    this.$store.dispatch('setCurrentProject', this.current_layer.project.hashid);
                });
                this.$store.dispatch('getUser');
            }
        },
        template () {
            return `
                <div class="dropzone-item">
                    <div class="dropzone-file">
                        <div class="dropzone-filename"  title="some_image_file_name.jpg">
                            <span data-dz-name>some_image_file_name.jpg</span>
                            <strong>(<span data-dz-size="">340kb</span>)</strong>
                        </div>
                        <div class="dropzone-error" data-dz-errormessage></div>
                    </div>
                    <div class="dropzone-progress">
                        <div class="progress">
                            <div
                                class="progress-bar bg-primary"
                                role="progressbar"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                aria-valuenow="0"
                                data-dz-uploadprogress
                            ></div>
                        </div>
                    </div>
                    <div class="dropzone-toolbar">
                        <span class="dropzone-delete" data-dz-remove="">
                            <i class="v-icon mdi mdi-close"></i>
                        </span>
                    </div>
                </div>
            `;
        },
        dropError (e, message){
            this.errorFiles++;
            e.previewElement.querySelector('.dropzone-error').innerHTML = message.error_message;
        }
    },
    created () {
        if (this.current_layer.layer.id != 0) this.dropzoneEnabled = false;
    }
};
</script>
